exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader/lib!./~/element-ui/lib/theme-chalk/submenu.css
// module id = 198
// module chunks = 0